/* =============================================================
   Birth Profile Analyst — brug naar de echte Shopify-checkout
   -------------------------------------------------------------
   Houdt het ontwerp (winkelwagen + checkoutformulier) intact,
   maar leidt het laatste "Betalen"-moment om naar de echte
   Shopify-checkout. Geboortegegevens, contactgegevens en de
   3 vragen reizen mee als regelgegevens + bestelnotitie.
   ============================================================= */
(function () {
  "use strict";

  // Design-pakket-id ("1".."3")  ->  Shopify numeriek variant-id
  var VARIANTS = {
    "1": 53383115473243,
    "2": 53383115637083,
    "3": 53383115669851
  };

  function readDesignCart() {
    try { return JSON.parse(localStorage.getItem("bpa_cart")) || []; }
    catch (e) { return []; }
  }
  function val(id) {
    var el = document.getElementById(id);
    return el ? (el.value || "").trim() : "";
  }
  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
  }

  function buildProps() {
    var p = {};
    var naam = (val("fn") + " " + val("ln")).trim();
    if (naam) p["Naam"] = naam;
    if (val("email"))  p["E-mail"] = val("email");
    if (val("tel"))    p["Telefoon"] = val("tel");
    var _b=(function(){try{return JSON.parse(localStorage.getItem("bpa_cart")||"[]")}catch(e){return[]}})().find(function(x){return x&&x.birth;});_b=(_b&&_b.birth)||{};if(_b.date)p["Geboortedatum"]=_b.date;
    if(_b.time)p["Geboortetijd"]=_b.time;
    if(_b.place)p["Geboorteplaats"]=_b.place;
    if (val("q1"))     p["Vraag 1"] = val("q1");
    if (val("q2"))     p["Vraag 2"] = val("q2");
    if (val("q3"))     p["Vraag 3"] = val("q3");
    return p;
  }

  function gatherItems(props) {
    var items = [];
    readDesignCart().forEach(function (it) {
      var vid = VARIANTS[String(it.id)];
      if (vid) items.push({ id: vid, quantity: it.qty || 1, properties: props });
    });
    if (!items.length) {
      var pid = new URLSearchParams(location.search).get("pakket");
      var vid = VARIANTS[String(pid)];
      if (vid) items.push({ id: vid, quantity: 1, properties: props });
    }
    return items;
  }

  function toShopifyCheckout() {
    var props = buildProps();
    var items = gatherItems(props);
    if (!items.length) { window.location.href = "/cart"; return; }
    var note = "Geboorteprofiel-bestelling via de site." + (props["Naam"] ? " Klant: " + props["Naam"] + "." : "");
    post("/cart/clear.js", {})
      .then(function () { return post("/cart/add.js", { items: items }); })
      .then(function () { return post("/cart/update.js", { note: note, attributes: props }); })
      .then(function () { window.location.href = "/checkout"; })
      .catch(function () { window.location.href = "/cart"; });
  }

  // Capture-fase op document: draait vóór het ontwerp-eigen submit-handler,
  // zodat we de Web3Forms-flow netjes overslaan.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.id !== "coForm") return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var consent = document.getElementById("consent");
    if (consent && !consent.checked) { consent.focus(); return; }
    var btn = document.getElementById("payBtn");
    if (btn) { btn.style.pointerEvents = "none"; btn.innerHTML = "Doorsturen naar betaling…"; }
    toShopifyCheckout();
  }, true);
})();
